/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-payment-history.reducer';

export const PharmacyPaymentHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyPaymentHistoryEntity = useAppSelector(state => state.pharmacyPaymentHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyPaymentHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.detail.title">PharmacyPaymentHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.id}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.paymentMethod}</dd>
          <dt>
            <span id="transactionDetails">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.transactionDetails">Transaction Details</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.transactionDetails}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.paidAmount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.paymentStatus}</dd>
          <dt>
            <span id="forCredit">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.forCredit">For Credit</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.forCredit ? 'true' : 'false'}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.modifiedByType}</dd>
          <dt>
            <span id="cancelledReason">
              <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.cancelledReason">Cancelled Reason</Translate>
            </span>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.cancelledReason}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyPaymentHistory.pharmacyStockBill">Pharmacy Stock Bill</Translate>
          </dt>
          <dd>{pharmacyPaymentHistoryEntity.pharmacyStockBill ? pharmacyPaymentHistoryEntity.pharmacyStockBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-payment-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-payment-history/${pharmacyPaymentHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyPaymentHistoryDetail;
